module.exports = __webpack_public_path__ + "static/media/1.4f94023d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/1.png
// module id = 790
// module chunks = 0